import React from 'react';
import { BoxProps } from '@chakra-ui/react';
import Card from '../Card';

const Section = (props: BoxProps) => <Card {...props} />;

Section.Header = Card.Header;
Section.Title = Card.Title;
Section.Description = Card.Description;

export default Section;
